import { render, staticRenderFns } from "./OptionLegendIndicator.vue?vue&type=template&id=35e3ee4e&scoped=true"
import script from "./OptionLegendIndicator.vue?vue&type=script&lang=js"
export * from "./OptionLegendIndicator.vue?vue&type=script&lang=js"
import style0 from "./OptionLegendIndicator.vue?vue&type=style&index=0&id=35e3ee4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e3ee4e",
  null
  
)

export default component.exports